import { DocstoreSections } from "../constants";

export const getSelectedSectionFromParams = (searchParams: URLSearchParams) => {
  const selectedSection = searchParams.get("documentType");
  if (!selectedSection) {
    return "PERMITS";
  }
  return selectedSection as keyof typeof DocstoreSections;
};
